import { twMerge } from "tailwind-merge";

export type AdminSeniorVoResponseStatus = "success" | "error";

interface Props {
  status: AdminSeniorVoResponseStatus;
  title: string;
  message: string;
  onClose: () => void;
}

const AdminSeniorVoResponseModal = ({ status, title, message, onClose }: Props) => (
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="admin-senior-vo-response-title"
    className="fixed inset-0 z-[60] flex items-center justify-center bg-black/45 px-4 py-6"
  >
    <section className="w-full max-w-md rounded-[28px] bg-white px-6 py-6 text-center shadow-[0_40px_120px_-48px_rgba(16,42,67,0.55)]">
      <div
        className={twMerge(
          "mx-auto flex h-14 w-14 items-center justify-center rounded-full text-sm font-semibold",
          status === "success" ? "bg-[#E1F6F2] text-[#0B8A7C]" : "bg-[#FFF1F1] text-[#BF0002]",
        )}
      >
        {status === "success" ? "OK" : "!"}
      </div>
      <h2 id="admin-senior-vo-response-title" className="mt-4 text-2xl font-semibold text-[#102A43]">
        {title}
      </h2>
      <p className="mt-3 text-sm leading-6 text-[#52606D]">{message}</p>
      <button
        type="button"
        onClick={onClose}
        className="mt-6 inline-flex h-11 items-center justify-center rounded-xl bg-[#0B8A7C] px-6 text-sm font-semibold text-white transition-colors hover:bg-[#0A796D]"
      >
        Close
      </button>
    </section>
  </div>
);

export default AdminSeniorVoResponseModal;
